export default {"src":"/_next/static/media/cost.1e6682e9.svg","height":133,"width":303,"blurWidth":0,"blurHeight":0};